import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { successToast } from '@securitize/ui-components/Toast';
import InvestorQualification from '../InvestorQualification';
import { authoriseWallet } from '../../Portfolio/components/Wallets/actions';

const AddWalletQualification = ({ tempAuthWalletData, authoriseWallet }) => {
  const addWalletHandler = () => {
    authoriseWallet(tempAuthWalletData, {
      onSuccess: () => successToast('Wallet is authorizing'),
    });
  };
  return (
    <InvestorQualification onSubmitSuccess={addWalletHandler} />
  );
};

AddWalletQualification.propTypes = {
  tempAuthWalletData: PropTypes.objectOf(PropTypes.any),
  authoriseWallet: PropTypes.func,
};

AddWalletQualification.defaultProps = {
  tempAuthWalletData: {},
  authoriseWallet: () => {},
};

const mapStateToProps = ({ wallets }) => ({
  tempAuthWalletData: wallets.tempAuthWalletData,
});

export default connect(mapStateToProps, {
  authoriseWallet,
})(AddWalletQualification);
